module.exports = __webpack_public_path__ + "img/hochiminh.d89398d5.jpg";